(() => {
  const toNumber = (s) => Number(String(s || '').replace(/,/g, '')) || 0;
  const format = (n) => Number(n || 0).toLocaleString('ja-JP');

  // SSRで埋め込まれた静的数値を整形（応援金・体験者数・希望者数）
  function hydrateStaticNumbers() {
    const items = Array.from(document.querySelectorAll('.try-store-item'));
    if (!items.length) return;

    items.forEach((item) => {
      // TRY応援金
      const ouenEl = item.querySelector('.store-ouenkin .amount .num');
      if (ouenEl) ouenEl.textContent = format(toNumber(ouenEl.textContent));

      // 体験者数（加盟店に出る場合）
      const taikenEl = item.querySelector('.store-taiken .amount .num');
      if (taikenEl) taikenEl.textContent = format(toNumber(taikenEl.textContent));

      // 希望者数（未加盟店）
      const kibouEl = item.querySelector('.store-kibou .amount .num');
      if (kibouEl) kibouEl.textContent = format(toNumber(kibouEl.textContent));
    });
  }

  // WP側の最新希望者数をまとめてGETして表示に反映
  async function hydrateKibouCounts() {
    const items = Array.from(document.querySelectorAll('.try-store-item[data-store-id]'));
    if (!items.length) return;

    const ids = Array.from(new Set(items.map((el) => el.dataset.storeId).filter(Boolean)));
    if (!ids.length) return;

    try {
      const url = `/wp-json/sinthia/v1/kibou?store_ids=${encodeURIComponent(ids.join(','))}`;
      const res = await fetch(url, { method: 'GET', credentials: 'same-origin' });
      if (!res.ok) return;

      const data = await res.json();
      const map = data?.kibou || {};

      items.forEach((item) => {
        const id = item.dataset.storeId;
        if (!id || typeof map[id] !== 'number') return;

        const numEl = item.querySelector('.store-kibou .amount .num');
        if (!numEl) return;

        numEl.textContent = format(map[id]);
      });
    } catch (e) {
      // 取得失敗なら何もしない（SSR値のまま）
    }
  }

  // Cookie（30日）で同一店舗への連打抑止
  const COOKIE_DAYS = 30;

  const getCookie = (name) => {
    const m = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : '';
  };

  const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/; samesite=lax`;
  };

  // 初回
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      hydrateStaticNumbers();
      hydrateKibouCounts();
    });
  } else {
    hydrateStaticNumbers();
    hydrateKibouCounts();
  }

  // クリック → 楽観更新 → POST → サーバ値で確定
  document.addEventListener('click', async (e) => {
    // ★今回：picture.store-button の中の img をクリックしても拾えるよう closest で取る
    const btn = e.target.closest('.try-store-item.is-non-partner .store-button');
    if (!btn) return;

    const item = btn.closest('.try-store-item');
    const storeId = item?.dataset?.storeId;
    if (!storeId) return;

    const cookieKey = `try_kibou_${storeId}`;
    if (getCookie(cookieKey)) {
      btn.classList.add('is-disabled');
      return;
    }

    const numEl = item.querySelector('.store-kibou .amount .num');
    if (!numEl) return;

    const current = toNumber(numEl.textContent);

    // 楽観更新
    numEl.textContent = format(current + 1);
    btn.classList.add('is-sending');

    try {
      const res = await fetch('/wp-json/sinthia/v1/kibou', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // ★トークン方式の場合：ここにヘッダー追加
        // headers: { 'Content-Type': 'application/json', 'X-Sinthia-Token': '...' },
        body: JSON.stringify({ store_id: storeId }),
        credentials: 'same-origin',
      });
      if (!res.ok) throw new Error('request failed');

      const data = await res.json();

      // サーバーが返す最新値（合算後）で確定
      if (typeof data.kibou === 'number') {
        numEl.textContent = format(data.kibou);
      }

      // cookieセット（念のため）
      setCookie(cookieKey, '1', COOKIE_DAYS);
      btn.classList.add('is-disabled');
    } catch (err) {
      // 失敗時は戻す
      numEl.textContent = format(current);
    } finally {
      btn.classList.remove('is-sending');
    }
  });
})();
